export const formatPhoneNumber = (phoneNumber: string) => {
  const phone = phoneNumber.replace(/\D/g, "").slice(0, 10);
  if (phone.length >= 7) {
    return `(${phone.slice(0, 3)})${phone.slice(3, 6)}-${phone.slice(6)}`;
  } else if (phone.length >= 4) {
    return `(${phone.slice(0, 3)})${phone.slice(3)}`;
  }
  return phone;
};

export const formatDate = (date: string) => {
  const newDate = date.replace(/\D/g, "").slice(0, 8);
  if (newDate.length >= 5) {
    return `${newDate.slice(0, 2)}/${newDate.slice(2, 4)}/${newDate.slice(4)}`;
  } else if (newDate.length >= 3) {
    return `${newDate.slice(0, 2)}/${newDate.slice(2)}`;
  }
  return newDate;
};

export const formatNumber = (number: number, digit = 2) => {
  if (number) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    }).format(number);
  } else {
    return 0;
  }
};
